import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms: React.FC = () => (
  <main className="max-w-3xl mx-auto py-16 px-6 text-neutral-800">
    <Helmet>
      <title>Terms of Use | rAIn Automation IDX</title>
      <meta
        name="description"
        content="Review the Terms of Use for rAIn Automation IDX. Understand your rights and responsibilities when using our platform to access MLS listings."
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://idx.rainautomation.com/terms" />
    </Helmet>

    <h1 className="text-4xl font-extrabold tracking-tight mb-8 text-center">
      Terms of Use
    </h1>
    <p className="text-lg leading-relaxed mb-10 text-center text-neutral-600">
      Please review the following terms carefully. By accessing this site, you agree to comply with these conditions of use.
    </p>

    <div className="space-y-10 divide-y divide-neutral-200">
      <section className="pt-0">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">1. Use of Site</h2>
        <p className="text-base leading-relaxed">
          This website is for informational purposes only. All listing data is provided by FMLS and is deemed reliable but not guaranteed.
          You agree not to misuse, scrape, or attempt unauthorized access to any part of the site or its data.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">2. Intellectual Property</h2>
        <p className="text-base leading-relaxed">
          All content, trademarks, and data on this site are the property of rAIn Automation IDX, FMLS, or their licensors. You may not copy,
          reproduce, or distribute any part of this site without written permission.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">3. Disclaimer</h2>
        <p className="text-base leading-relaxed">
          All information is provided "as is" without any warranties. We do not guarantee the accuracy or completeness of any listing or information provided on the site.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">4. Limitation of Liability</h2>
        <p className="text-base leading-relaxed">
          rAIn Automation IDX and its affiliates will not be liable for any damages arising out of your use of this website.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">5. Changes to Terms</h2>
        <p className="text-base leading-relaxed">
          We reserve the right to update these terms at any time. Continued use of the site after changes constitutes acceptance.
        </p>
      </section>

      <section className="pt-10">
        <h2 className="text-2xl font-semibold mb-3 text-neutral-900">6. Contact</h2>
        <p className="text-base leading-relaxed">
          For questions regarding these Terms of Use, please contact us at{' '}
          <a
            href="mailto:support@rainautomation.com"
            className="text-blue-700 underline hover:text-blue-900 transition-colors"
          >
            support@rainautomation.com
          </a>.
        </p>
      </section>
    </div>
  </main>
);

export default Terms;